import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateRange from '../../../../commonComponents/forms/inputs/DateRange';
import FormInput from '../../../../commonComponents/forms/FormInput';
import translate from '../../../../commonComponents/translate';
import ConfigsContext from '../../../../contextProviders/ConfigsContext';

function CareerFilters(props) {
  const { t, filters, onDateChange, onUserChange, selectedUser } = props;
  const { organization } = useContext(ConfigsContext);
  const { directSelling } = organization;
  const { dateStart, dateEnd } = filters;

  // All presets use moment objects (not .valueOf()) for daterangepicker compatibility.
  const dateRanges = {
    [t('dateRange_thisMonth')]: [
      moment().utc().startOf('month'),
      moment().utc().endOf('month'),
    ],
    [t('dateRange_lastMonth')]: [
      moment().utc().subtract(1, 'months').startOf('month'),
      moment().utc().subtract(1, 'months').endOf('month'),
    ],
    [t('dateRange_twoMonthsAgo')]: [
      moment().utc().subtract(2, 'months').startOf('month'),
      moment().utc().subtract(2, 'months').endOf('month'),
    ],
    [t('dateRange_threeMonthsAgo')]: [
      moment().utc().subtract(3, 'months').startOf('month'),
      moment().utc().subtract(3, 'months').endOf('month'),
    ],
    [t('dateRange_fourMonthsAgo')]: [
      moment().utc().subtract(4, 'months').startOf('month'),
      moment().utc().subtract(4, 'months').endOf('month'),
    ],
  };

  // Normalise to a single full calendar month: regardless of what the user
  // dragged on the calendar, always send startOf(sDate's month) → endOf(sDate's month).
  const handleDateChange = useCallback(
    ({ startDate: sDate }) => {
      if (!sDate) {
        onDateChange(null, null);
        return;
      }
      const start = moment(sDate).utc().startOf('month').valueOf();
      const end = moment(sDate).utc().endOf('month').valueOf();
      onDateChange(start, end);
    },
    [onDateChange],
  );

  const userInputProps = {
    allowClear: false,
    url: '/user/table/network/list?isMinified=true',
    filterUrl: '/table/user/network/minified/list?type=collaborator',
    query: {
      type: 'collaborator',
    },
  };

  return (
    <div className="filters-wrapper">
      <div className="career-filter-container">
        <FormInput
          id="selectedUser"
          value={selectedUser}
          name="selectedUser"
          disabled={false}
          placeholder={t('user')}
          type="users"
          onChange={onUserChange}
          inputProps={userInputProps}
        />
      </div>
      <div className="career-filter-container">
        <DateRange
          directSellingSettings={directSelling}
          id="dateRange"
          placeholder={t('report.arcova.searchDate')}
          startDate={dateStart}
          endDate={dateEnd}
          onChange={handleDateChange}
          onClear={() => onDateChange(null, null)}
          customRanges={dateRanges}
          forceMonthBounds
        />
      </div>
    </div>
  );
}

CareerFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onUserChange: PropTypes.func.isRequired,
  selectedUser: PropTypes.string,
  filters: PropTypes.shape({
    dateStart: PropTypes.number,
    dateEnd: PropTypes.number,
  }).isRequired,
};

CareerFilters.defaultProps = {
  selectedUser: null,
};

export default translate(CareerFilters);
